import React from "react";
import { useNavigate } from "react-router-dom"
import { BiPalette, BiHistory, BiUpload } from "react-icons/bi"; // Modern icons
import "./css/index.css";

export const Navbar = ({ historyCount, generateColors, onHistoryClick, handleColorModes, handleExport, showModes, openExport, showHistory }) => {

    const navigate = useNavigate()

  return (
    <div className="navbar">
      <div className="nav-logo">
        {/* <GiPaintBrush onClick={()=> navigate("/home")} className="logo-icon" /> */}
<span onClick={() => navigate("/home")} className="logo-text">
  <span className="logo-half-colored">World</span>Paint
</span>        <div onClick={generateColors} className="manual-mobile">
        Tap here to generate colors
      </div>
      </div>



      {/* Palette (Color Modes) */}
   <div className="nav-items">

  {/* Modes */}
  <div
    className={`nav-item ${showModes ? "active" : ""}`}
    onClick={handleColorModes}
  >
    <BiPalette className="nav-icon" title="Modes" />
  </div>

  {/* History */}
  <div
    className={`nav-item history-count ${showHistory ? "active" : ""}`}
    onClick={onHistoryClick}
  >
    {historyCount > 0 && <span>{historyCount}</span>}
    <BiHistory className="nav-icon" title="History" />
  </div>

  {/* Export */}
  <div
    onClick={handleExport}
    className={`nav-item ${openExport ? "active" : ""}`}
  >
    <BiUpload className="nav-icon" title="Export" />
  </div>

</div>

      <div className="manual">
        Press <span className="manual-key">Space</span> to generate colors
      </div>
    </div>
  );
};